module.exports = __webpack_public_path__ + "static/img/309.45c5035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200513/309.jpg
// module id = Yr6t
// module chunks = 0